<script lang="ts">
	import { getContext, onMount } from "svelte";
	import { replaceContext } from "@reperio-news/core.components/includes/Helpers";
	import { z } from "zod";
	import Data from "./Data";
	import ImageView from "@reperio-news/core.components/ImageView.svelte";
	import Hydrator from "@reperio-news/core.components/Hydrator.svelte";
	import { sanitizeHTML } from "../../includes/helpers.svelte";
	type Data = z.infer<typeof Data>;
	export let id: string;
	export let data: Data = {};

	let image: any;
	$: image = data.image_from_context || data.image;
	const context: SvelteStore<any> = getContext("context");
	let expanded: boolean = false;
	let expandable: boolean = false;

	let textDom: HTMLDivElement;

	let mounted = false;

	//	textDom is null mid-flight while Hydrator swaps its {#if} branches
	//	after mount; keyed on the dom ref so it re-runs after re-bind
	$: if (mounted && textDom) {
		expandable = textDom.scrollHeight > textDom.clientHeight;
	}

	onMount(() => {
		mounted = true;
	});
</script>

<Hydrator props={$$props} component="PageHeaderBanner" hydrate={true}>
	<div class="pageHeaderBanner" class:expanded class:expandable>
		<div class="inside">
			<h1>{replaceContext(data.title, $context)}</h1>
			<div class="text">
				<div class="content" bind:this={textDom}>
					{@html sanitizeHTML(replaceContext(data.html, $context), [
						"a",
						"div",
						"h1",
						"h2",
						"h3",
						"p",
						"br",
						"i",
						"b",
						"font",
						"strong",
						"em",
						"ul",
						"ol",
						"li",
					])}
				</div>

				{#if !expanded}
					<span class="readAll" on:click={() => (expanded = true)}
						>Citește în continuare</span
					>
				{/if}
			</div>

			{#if image}
				<div class="image">
					<ImageView
						src={image}
						widths={[750, 350]}
						heights={[750, 350]}
						fit="contain"
					/>
				</div>
			{/if}
		</div>
	</div>
</Hydrator>

<style lang="scss">
	.pageHeaderBanner {
		width: 100%;
		margin: 10px auto 10px auto;
		padding: 0;
		background-color: #f2f2f2;
		box-shadow: 1px -8px 11px -11px rgba(0, 0, 0, 0.35) inset;

		.inside {
			h1 {
				padding: 0;
				margin: 0 0 10px 0;
				width: 100%;
				text-align: left;
				border-bottom: 1px solid #dfdfdf;
			}

			padding: 10px;
			width: calc(100% - var(--containerPadding, 10) * 2);
			display: flex;
			flex-direction: row;
			justify-content: center;
			align-items: center;
			flex-wrap: wrap;
			max-width: 1200px;
			margin: auto;
			justify-content: space-between;
			align-items: flex-start;

			.text {
				color: #111;
				width: calc(65% - 10px);
				.content {
					height: 200px;
					overflow: hidden;
					margin-bottom: 10px;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					white-space: normal;
					text-overflow: ellipsis;
					overflow: hidden;
					line-clamp: 9;
					-webkit-line-clamp: 9;
					line-height: 1.25em;

					:global {
						h2 {
							padding: 0;
							margin: 10px 0 10px 0;
							width: 100%;
							text-align: left;
							color: #000;
							text-shadow: none;
						}
					}
				}

				.readAll {
					font-style: italic;
					cursor: pointer;
					padding: 5px 5px 5px 0;
					display: block;
					text-decoration: underline;
					visibility: hidden;
				}
			}

			.image {
				width: calc(30% - 10px);
				padding: 10px;
				border-radius: 10px;
				height: 200px;
				transform: rotate(-2deg);

				:global {
					img,
					picture {
						object-fit: contain;
					}
				}
			}
		}
	}

	.expandable .inside .text span.readAll {
		visibility: visible;
	}

	div.expanded {
		.inside {
			.text {
				div.content {
					height: auto;
					overflow: auto;
					display: block;
					white-space: normal;
					text-overflow: initial;
					line-height: 1.25em;
				}
			}
		}
	}

	@media only screen and (max-width: 600px) {
		.pageHeaderBanner {
			.inside {
				.text {
					order: 2;
					width: 100%;

					.content {
						height: 70px;
					}
				}

				div.image {
					width: 100%;
					padding: 0;
					margin-bottom: 10px;
				}
			}
		}
	}
</style>
